<template>
  <div>
    <div>
      <!--国际服务订单,不展示该字段-->
      <el-button v-if="isShowInternationalServiceOrders!==1" type="primary" @click="printPdf">
        打印合同
      </el-button>
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button :type="isShowInternationalServiceOrders !==1 ? 'default' : 'primary'">
          上传合同
        </el-button>
      </el-upload>

      <el-button type="default" @click="downFiles">
        下载合同
      </el-button>
      <el-button v-if="isShowEsing" type="default" @click="goEsing">
        电子签章
      </el-button>
      <p style="color:red;margin-top:5px">
        注：

        1.若使用纸质版合同，请先点击“打印合同”，打印出纸质合同盖章后再上传合同附件；

        2.若使用电子版合同，请点击“电子签章”进行签章，签章完成后会自动生成合同附件。
      </p>
    </div>
    <ul class="el-upload-list el-upload-list--text" style="margin: 10px 0">
      <el-row :gutter="60">
        <el-col v-for="(item ,index) in fileList" v-show="item.loading" :key="index" :span="9" class="el-col-auto">
          <li tabindex="0" class="el-upload-list__item is-success">
            <a class="el-upload-list__item-name">
              <i class="el-icon-document" />
              {{ item.enclosureName }}
            </a>
            <label v-if="!item.loading" class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check" />
            </label>
            <el-progress v-if="item.loading" style="margin-top: 5px" :percentage="item.percentage" :stroke-width="4" :show-text="false" />
          </li>
        </el-col>
      </el-row>
    </ul>
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="left" />
      <el-table-column prop="fileName" label="文件名称" align="left">
        <template v-slot="{row}">
          <el-button type="text" class="el-btn-text-left" @click="openContract(row)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="updateTime" label="最后更新时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" width="100">
        <template v-slot="{row}">
          <el-popover v-model="row.removeVisible" width="170">
            <p style="line-height: 30px">
              确认删除该文件吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="row.removeVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="removeFile(row)">
                确定
              </el-button>
            </div>
            <el-button v-if="row.createBy === $store.state.user.userId" slot="reference" type="text" style="color: #F56C6C; margin-right: 10px;">
              删除
            </el-button>
          </el-popover>
          <el-button type="text" @click="downOneFile(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <do-esign ref="doEsign" @CompleteEsign="CompleteEsign" />
  </div>
</template>
<script type="es6">
import { getAttachmentListByContractId, attachmentGetToken, uploadAfterSaveInfo, deleteByContractIdAndAttachmentId, electronicSignature, printContractPDF, getUrlByFileID } from '@/API';
import doEsign from '@/components/doEsign';
import AxiosApi from '@/API/fileAxios';
import { getAliOSSDownloadInfo } from '@/API/international';

export default {
  data () {
    return {
      tableData: [],
      multipleSelection: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      isShowInternationalServiceOrders: 0 // 是否是国际服务订单,用户控制baseInfo组件中的电源线规则是否显示
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    },
    contractType: {
      type: String,
      default: ''
    },
    isInit: {
      type: Boolean,
      default: true
    },
    itemVal: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    doEsign
  },
  computed: {
    isShowEsing () {
      if (['国际分销下单', '国际业务下单'].includes(this.contractType)) return false;
      if (this?.itemVal?.contractType !== '服务订单') return true;
      // 如果是订单员 && 是服务订单 && 不是老ecp 就隐藏
      if (this.$store.getters.isAgent && this.itemVal.contractType === '服务订单') {
        if (this.itemVal.sources !== 'NEW-ECP') {
          return false;
        }
      };
      // 否则显示
      return true;
    }
  },
  methods: {
    searchFiles () {
      this.tableLoading = true;
      getAttachmentListByContractId(this.contractNum).then((res) => {
        const json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    downFiles () {
      if (!this.multipleSelection.length) {
        this.$notify({
          title: '请至少选择一个文件',
          type: 'warning'
        });
        return;
      }
      if (this.multipleSelection.length === 1) {
        this.downOneFile(this.multipleSelection[0]);
      } else {
        // const fileIds = [];

        this.multipleSelection.forEach((item) => {
          setTimeout(() => {
            this.downOneFile(item);
          }, 200);
        });

        // getTokenForDownZip({
        //   catalogName: '回执单附件集合',
        //   fileIds
        // }).then((res) => {
        //   const json = res.data;
        //   if (json.status === '200') {
        //     this.downzipFile(json.data.token, json.data.downloadZipUrl);
        //   }
        // }).catch(() => {
        //
        // });
      }
    },
    downOneFile (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            this.fileserveDownUrl = data.fileInfo.url;
            this.$nextTick(() => {
              this.$refs.downTag.click();
            });
          }
        }).catch(() => {
        });
      } else {
        this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
        this.$nextTick(() => {
          this.$refs.downTag.click();
        });
      }
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitfile (files) {
      this.tableLoading = true;
      uploadAfterSaveInfo(files).then((res) => {
        const json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.searchFiles();
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    checkSpecialCharacters (str) {
      // return str.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '');
      // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.submitfile([{
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            contractId: this.contractNum
          }]);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (row) {
      this.tableLoading = true;
      deleteByContractIdAndAttachmentId({
        contractId: row.contractId,
        attachmentId: row.id
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (!json.data) this.$message.error('该附件不可删除');
          this.searchFiles();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    goEsing () {
      electronicSignature(this.contractNum).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data);
        }
      }).catch(() => {

      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.searchFiles();
      }
    },
    printPdf () {
      printContractPDF(this.contractNum).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fileserveDownUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(json.data)}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }).catch(() => {

      });
    },
    openContract (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            window.open(data.fileInfo.url);
          }
        }).catch(() => {
        });
      } else {
        getUrlByFileID(row.fileToken).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            window.open(json.data);
          }
        }).catch((res) => {

        });
      }
    },
    /**
     * 对外提供获取合同列表的接口
     * @returns {Array} 合同列表
     */
    getContractList () {
      return this.tableData;
    }
  },
  mounted () {
    if (this.isInit) {
      this.searchFiles();
    }
    this.initToken();
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
